<template>
    <div class="labels">
        <template v-for="label in labels" :key="label.name" >
            <div class="labels__item" :class="{ 'labels__item--new' : label.name === 'new', 'labels__item--last' : label.name === 'last_chance' }" @click.prevent.stop=setActiveLabel(label.name)>
                <IconLabelNew v-if="label.name === 'new'" class="icon"></IconLabelNew>
                <IconLabelLast v-if="label.name === 'last_chance'" class="icon"></IconLabelLast>
                <span v-if="label.title" class="labels__item-tooltip" :class="{'active' : activeLabel === label.name }">{{ label.title }}</span>
            </div>
        </template>
    </div>
</template>

<script>
import IconLabelNew from "./icons/IconLabelNew.vue";
import IconLabelLast from "./icons/IconLabelLast.vue";

export default {
    name: "Labels",
    props: {
        labels: {
            type: Array,
            required: true,
        },
        id: {
            type: Number
        }
    },
    data() {
        return {
            activeLabel: ''
        };
    },
    components: {
        IconLabelNew,
        IconLabelLast
    },
    computed: {
        getActiveTooltip() {
            return this.$store.getters.getActiveTooltip;
        },
    },
    watch: {
        getActiveTooltip: {
            handler: function(value) {
                if(value.id !== this.id) {
                    this.activeLabel = '';
                }
            },
            deep: true,
            immediate: true            
        }
    },
    methods: {
        setActiveLabel(name) {
            if(this.activeLabel && this.activeLabel === name) {
                this.activeLabel = '';
                this.$store.dispatch("setActiveTooltip", {});
            } else {
                this.activeLabel = name;
                this.$store.dispatch("setActiveTooltip", {name: this.activeLabel, id: this.id});
            }
        }
    }
};
</script>